/**
 * ============================================================================
 *  SITE CONFIGURATION
 * ----------------------------------------------------------------------------
 *  Edit the values below to rebrand this template. These are the main knobs
 *  used across the app (header, footer, SEO, contact, payment page, etc.).
 * ============================================================================
 */

export const siteConfig = {
  brand: {
    name: 'Flash USDT Software Shop',
    tagline: 'Flash USDT Software Shop — Buy Flash USDT Software Online',
    description:
      'Flash USDT Software Shop is the online store for licensed flash USDT software. Multi-chain (TRC-20, ERC-20, BEP-20), 50+ compatible wallets, 24/7 support, and flash validity up to 365 days.',
  },

  domain: 'https://flashusdtsoftwareshop.com',

  contact: {
    orderEmail: 'buyflashusdtsoftware@gmail.com',
    supportEmail: 'buyflashusdtsoftware@gmail.com',
    whatsapp: '447950911750',
    phoneDisplay: '+44 7950 911750',
  },

  social: {
    twitter: 'https://twitter.com/yourbrand',
    facebook: 'https://facebook.com/yourbrand',
    instagram: 'https://instagram.com/yourbrand',
    telegram: 'https://t.me/yourbrand',
  },

  payment: {
    wallets: {
      bitcoin: 'bc1q6eh6s2ycyzgzvp6dgkx8lhgnaefnfm3pe9w79d',
      usdt: 'TKcSCgxQ6xhM65oEoogES51TqQs5zURQHd',
    },
  },
};

export default siteConfig;
